import type { DnsRecordListItemBase, DnsRecordListType } from "./types.js";
import type { DnsZoneCommon } from "../DnsZone/index.js";
import type { DnsRecordSettingsData } from "../DnsRecordSettings/index.js";
import type { IngressCommon } from "../Ingress/index.js";
import { getSubdomain } from "tldts";

export abstract class DnsRecordListBase<T extends DnsRecordListItemBase> {
  public items: T[];
  public readonly parentZone: DnsZoneCommon;
  public readonly ingress: IngressCommon;
  protected constructor(
    items: T[],
    parentZone: DnsZoneCommon,
    ingress: IngressCommon,
  ) {
    this.items = items.map((i) => ({ ...i, type: "unchanged" }));
    this.parentZone = parentZone;
    this.ingress = ingress;
  }

  public getItems(exclude?: DnsRecordListType[]) {
    if (exclude) {
      return this.items.filter((i) => !exclude.includes(i.type));
    }
    return this.items;
  }

  public getPrefix(domain: string): string {
    const subdomain = getSubdomain(domain);
    if (subdomain === null) {
      return "";
    }
    return subdomain;
  }

  protected abstract addItem(item: T): void;
  protected abstract updateItem(oldItem: T, newItem: T): void;
  protected abstract deleteItem(item: T): void;
  protected abstract saveItems(
    settings: DnsRecordSettingsData,
  ): void | Promise<void>;
}
